import {_, React, classNames, withStyles, StyledProps, qs, utils, Fragment} from '@api'
import {InfoCardConfig, Badge, LazyLoadMedia, Placeholder, PrimaryIconButton, ListPreviewCard, CentricTheme, LazyAvatar, DropIndicator, Loading, ViewConfigMapping, CardSizeType, MyImage} from 'centric-ui-components'
import { MoreHoriz, Link, Comment, FavoriteBorder, Check, GetApp, Add } from '@material-ui/icons'
import { Card, Divider, Typography, CardActions, CardContent, CircularProgress, Chip, List } from '@material-ui/core'
import {nav, site, ICardUIConfig, Stores} from '@stores'
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as css from './ListInfoCard.css'

const styles = (theme: CentricTheme) => ({
  large_card: {
    width: 224,
    margin: theme.cssVars.cardSpacing,
    position: 'relative',
    '& .inactive': {
      opacity: '0.5'
    },
    '&:hover': {
      boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)'
    },
    cursor: 'pointer',
    zIndex: 0
  },
  medium_card: {
    width: 160,
    cursor: 'pointer',
    position: 'relative',
    margin: 8,
    zIndex: 0,
    '& .inactive': {
      opacity: '0.5'
    },
    '&:hover': {
      boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)'
    }
  },
  large_cardSelected: {
    backgroundColor: 'rgba(65, 132, 243, 0.12)',
    '&:hover': {
      boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)'
    }
  },
  medium_cardSelected: {
    backgroundColor: 'rgba(65, 132, 243, 0.12)',
    '&:hover': {
      boxShadow: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)'
    }
  },
  large_badgeWrapper: {
    display: 'flex',
    height: 18,
    alignItems: 'center ',
    margin: `${theme.spacing() * 2}px ${theme.spacing() * 2}px 0`
  },
  medium_badgeWrapper: {
    display: 'flex',
    height: 18,
    alignItems: 'center ',
    marginBottom: theme.spacing()
  },
  xlarge_content: {
    padding: 0,
    borderBottom: 'thin solid #DEDEDE',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  large_content: {
    padding: 0,
    borderBottom: 'thin solid #DEDEDE',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  medium_content: {
    padding: 0,
    borderBottom: 'thin solid #DEDEDE',
    '&:last-child': {
      paddingBottom: 0
    }
  },
  large_nocontent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  medium_nocontent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  linkIcon: {
    color: 'rgba(0, 0, 0, 0.38)',
    position: 'absolute',
    right: 0,
    '& svg': {
      width: 20,
      height: 20
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  large_infoContainer: {
    display: 'flex',
    position: 'relative'
  },
  large_infoContainerWithLink: {
    display: 'flex',
    position: 'relative',
    margin: `${theme.spacing()}px ${theme.spacing() * 2}px`
  },
  medium_infoContainer: {
    display: 'flex',
    position: 'relative'
  },
  large_body1: {
    // FIXME: Change this back 2
    // NOTE: Changed to 1 temporarily as it is affecting height of card and we need this for next week's demo
    '-webkitLineClamp': '1 !important'
  },
  medium_body1: {
    '-webkitLineClamp': 1,
    fontSize: `12px !important`,
    height: 18
  },
  medium_secondaryText: {
    fontSize: `10px !important`,
    height: 16
  },
  small_body1: {
    '-webkitLineClamp': 1,
    fontSize:           `12px`,
    height:             16
  },

  body2: {
    fontWeight: 'normal',
    color: 'rgba(27, 27, 27, 0.54)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: 0,
    whiteSpace: 'nowrap',
    width: 225
  },
  medium_actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 32,
    padding: 0
  },
  large_actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 48
  },
  medium_action_progress: {
    display: 'flex',
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center'
  },
  large_action_progress: {
    display: 'flex',
    width: '48px',
    height: '48px',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center'
  },
  large_infoWithLink: {
    width: 180
  },
  large_infoWithOutLink: {
    margin: `${theme.spacing()}px ${theme.spacing() * 2}px`
  },
  medium_infoWithLink: {
    width: 96
  },
  chipContainer: {
    margin: theme.spacing() * 2
  },
  chip: {
    backgroundColor: '#F5F5F5',
    color: 'rgba(27, 27, 27, 0.54)',
    margin: theme.spacing() / 2,
    height: (theme.spacing() * 4) + 4,
    borderRadius: (theme.spacing() * 2) + 2,
    cursor: 'pointer'
  },
  chipLabel: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 210,
    whiteSpace: 'nowrap',
    display: 'inline-block',
    fontSize: 12,
    color: 'rgba(27, 27, 27, 0.54)'
  },
  large_moreIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    width: 20,
    height: 20
  },
  medium_moreIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    width: 16,
    height: 16
  },
  commentsIcon: {
    color: 'rgba(0, 0, 0, 0.54)',
    transform: 'scaleX(-1)',
    width: 20,
    height: 20
  },
  titleContainer: {
    display: 'flex'
  },
  left: {
    marginLeft: theme.spacing()
  },
  badgeContainer: {
    margin: `${theme.spacing()}px 0`,
    height: 18
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  list: {
    padding: '0'
  },
  card: {
    padding: '16px',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  inactive: {
    '& .inactive': {
      opacity: '0.5'
    }
  },
  dragImage: {
    opacity: 0,
    position: 'absolute',
    transition: 'opacity 0.5s ease-in-out'
  },
  dragOverCard: {
    opacity: '1 !important',
    pointerEvents: 'auto',
    zIndex: 2,
    height: '100%'
  },
  dragImageArea: {
    backgroundColor: '#cddefd !important'
  },
  previewSelected: {
    backgroundColor: 'transparent !important'
  },
  medium_list: {
    minHeight: '0 !important',
    padding: '0 !important'
  },
  medium_cardHeight: {
    minHeight: '0 !important',
    padding: `4px 8px !important`
  },
  icon: {
    width: '24px !important',
    height: '24px !important'
  },
  success: {
    width: '100%',
    position: 'absolute',
    top: '0',
    height: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    transition: 'opacity 500ms ease-in-out',
    overflow: 'hidden',
  },
  spec_success: {
    width: '100%',
    position: 'absolute',
    top: '30px',
    height: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    transition: 'opacity 500ms ease-in-out',
    overflow: 'hidden',
  },
  spec_success_image: {
    height: 160,
    opacity: 1
  },
  success_image: {
    height: 160,
    opacity: 1,
    zIndex: 1
  },
  success_large_image: {
    height: 224,
    opacity: 1,
    zIndex: 1
  },
  green_check: {
    backgroundColor: 'rgba(0, 128, 0, 0.75)',
    color: '#FFF',
    borderRadius: '50% 50%',
    height: 30,
    width: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  green_check_large: {
    backgroundColor: 'rgba(0, 128, 0, 0.75)',
    color: '#FFF',
    borderRadius: '50% 50%',
    height: 36,
    width: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inactiveText: {
    position: 'absolute',
    left: 8,
    fontSize: 12,
    color: 'rgba(27, 27, 27, 0.54)'
  },
  disabled: {
    opacity: '0.5'
  },
  green : {
    color: 'rgba(0, 128, 0, 0.75)'
  },
  disabledIcon: {
    cursor: 'default'
  },
  darkIcon: {
    color: 'var(--icon-grey-1)'
  }
})

interface MyProps extends StyledProps {
  data?: InfoCardConfig
  cardSize?: CardSizeType
  isContent?: boolean
  onDragEnterImage: (e, id) => void
  onDragLeaveImage: (e, id) => void
  loading?: string[]
  drag?: string[]
  isActions?: boolean
  isAttributes?: boolean
  isComments?: boolean
  isSelected?: boolean
  onClickComment?: (e, id) => void
  onClickPlaceholder?: (e, id) => void
  showFavorite?: boolean
  onClickMoreMenu: (e) => void
  onClickFavorite: (e, id) => void
  onDragEnterSpecification?: (e, v: 'tag') => void
  onDragLeaveSpecification?: (e, v: 'tag') => void
  mapping?: Array<ViewConfigMapping>
  badge1Text?: string
  badge2Text?: string
  showHex?: boolean
  showImage?: boolean
  onClick?: (e, id) => void
  onDragStart?: (e) => void
  onDragEnd?: (e) => void
  onDropImage?: (e, data) => void
  onDoubleClick?: (e) => void
  draggable?: boolean
  success?: string[]
  showAddedText?: boolean
  disableAddToSeason?: boolean
  showDownload?: boolean
  showDownloadInProgress?: boolean
  showMenu?: boolean
  showCheck?: boolean
  onClickDownload?: (e, data) => void
  onClickPlus?: (e, data) => void
  dragType?: string,
  sizes?: {[type: string]: number}
  hideInfo?: boolean,
  newSpecification?: any
  showAddIcon?: boolean
  onDrop?: (e) => void
  onClickAddIcon?: (e) => void
  cardDetails?: ICardUIConfig
  searchText?: string
  stores?: Partial<Stores>
}

const ATTRIBUTE    = 'attribute'
const MEDIUM_IMAGE = 'mediumImage'

/**
 * Used in left sidebar catalog items list when in list view
 * TODO - refactor to hooks and no props
 */
@(withStyles as any)(styles)
@observer
export class ListInfoCard extends React.Component<MyProps> {
  static defaultProps = {
    isContent: true,
    cardSize: 'large',
    showImage: true,
    showHex: true,
    data: {},
    onClick: () => {},
    onClickComment: () => {},
    onClickFavorite: () => {},
    onClickPlaceholder: () => {},
    onDragEnterImage: () => {},
    onDragLeaveImage: () => {},
    onDragEnterSpecification: () => {},
    onDragLeaveSpecification: () => {},
    onDropImage: () => {},
    onDragStart: () => {},
    onDragEnd: () => {},
    onClickMoreMenu: () => {},
    showMenu: true,
    draggable: true,
    sizes: {
      xlarge: null,
      large: 224,
      medium: 160,
      small: 48,
      mini: 24
    }
  }

  static configuration = {
    name: 'InfoCard',
    fields: [
      {
        name: 'image',
        type: 'LazyAvatar'
      },
      {
        name: 'title',
        type: 'ListItemText'
      },
      {
        name: 'subtitle1',
        type: 'ListItemText'
      },
      {
        name: 'subtitle2',
        type: 'ListItemText'
      },
      {
        name: 'subtitle3',
        type: 'ListItemText'
      }
    ]
  }

  get stores() { return this.props.stores}

  get catalog() { return this.stores.catalog}

  @computed get dataImages() {
    const {props: {data, cardDetails}} = this,
      primaryImageSrc = cardDetails?.main?.image?.field || "images"

    return _.get(data, primaryImageSrc)
  }

  @computed get image() {
    const {props: {data}, dataImages, catalog} = this
    let image = !data ? null
                      : data.hex ? data.hex
                                 : dataImages && !_.isEmpty(dataImages) ? _.first(dataImages) : null
    if (image && (image['image'] || image['exId'])) {
      image = catalog.imageUrlFor(image as any)
    }

    return image
  }

  @computed get isActive() {
    const {props: {data}} = this
    return _.has(data, 'active') ? data.active : true
  }

  @computed get qrCodeURL() {
    const {stores} = this, {catalog, site, nav: {queryParams: qp, params}} = stores
    const {props: {data}} = this

    let queryParams = {libraryId: data.id}
    // if (catalog) {
    //   Object.assign(queryParams, {groups: qp.groupBy}) //, filter: qp.filter})
    // }
    // let url = `${site.urlFor(workspaces.current)}?${utils.stringifyQs(queryParams)}`
    // return `${window.location.origin}${url}`

    return null
  }

  @computed get isLarge() {
    const {props: {cardSize}} = this
    return ['large', 'xlarge'].includes(cardSize)
  }

  render() {
    const {
       props: {
        data,
        cardSize,
        drag,
        loading,
        success,
        showHex,
        mapping,
        classes,
        onClick,
        draggable,
        isContent,
        showImage,
        onDragEnd,
        isActions,
        isComments,
        badge1Text,
        badge2Text,
        isSelected,
        onDragStart,
        onDropImage,
        showFavorite,
        isAttributes,
        onClickComment,
        onClickMoreMenu,
        onClickFavorite,
        onDragLeaveImage,
        onDragEnterImage,
        onClickPlaceholder,
        onDragEnterSpecification,
        onDragLeaveSpecification,
        showAddedText,
        disableAddToSeason,
        showMenu,
        onClickDownload,
        onClickPlus,
        showDownload,
        showDownloadInProgress,
        showCheck,
        className,
        sizes,
        dragType,
        hideInfo,
        children,
        newSpecification,
        showAddIcon,
        onClickAddIcon,
        onDrop,
        cardDetails,
        searchText,
        ...props
      }, isActive, image, dataImages, isLarge, stores, stores: {catalog: {dialogs: {showQrCodes}}}
    } = this

    const {vlp: {isVLPView}} = stores

    return (
      <Card
        data-size={cardSize}
        className={classNames(className, css.card, classes[`${cardSize}_card`], {
          [classes[`${cardSize}_cardSelected`]]: isSelected,
          [classes.inactive]: !isActive
        })}
        {...props}
        onClick={(e) => {data.id && onClick(e, data.id)}}
        // onDragStart={(e) => {!isVLPView && onDragStart && onDragStart(e, data.id)}}
        // onDragEnd={(e) => {!isVLPView && onDragEnd && onDragEnd(e, data.id)}}
        // onDragEnter={(e) => {!isVLPView &&  onDragEnterImage && onDragEnterImage(e, data.id) }}
        // onDragOver={(e) => { !isVLPView && onDragEnterImage && onDragEnterImage(e, data.id) }}
        draggable={!isVLPView && draggable}
      >
        {(dataImages && dataImages.length > 0 && !_.includes(loading, data.id) || (showHex && !_.isEmpty(data.hex) && !_.includes(loading, data.id))) &&
		 <LazyLoadMedia
			 cardSize={cardSize}
			 id={data.id}
			 showHex={showQrCodes ? false : showHex}
			 hex={showQrCodes ? null : data.hex}
			 isActive={isActive}
			 isSelected={isSelected}
			 onDragEnter={(e) => { !isVLPView && onDragEnterImage(e, data.id) }}
			 draggable={!isVLPView && draggable}
			 image={<MyImage showCode={showQrCodes}
                             imageUrl={{defaultImageUrl: image as string}}
                             linkUrl={this.qrCodeURL} draggable={!isVLPView && draggable}/>}
		 />}
        {(!dataImages || dataImages.length === 0) && !_.includes(loading, data.id) && showImage && _.isEmpty(data.hex) &&
		 <Placeholder
			 type={cardSize}
			 isActive={isActive}
			 avatar={cardDetails?.main?.image?.avatar}
			 className={css.placeholder}
			 isSelected={isSelected}
			 onClickPlaceholder={(e) => { !isVLPView && onClickPlaceholder && onClickPlaceholder(e, data.id) }}
		 />}

        {_.includes(loading, data.id) && <Loading
			size={["xlarge", "large"].includes(cardSize) ? 30 : 20}
			className={classNames({[css.xlarge_placeHolder]: cardSize === 'xlarge', [css.large_placeHolder]: cardSize === 'large'}, {[css.small_placeHolder]: cardSize !== 'large'})}/>}
        {success && <div className={classNames(
          classes.success,
          {[classes.success_image]: !["xlarge", "large"].includes(cardSize) && _.includes(success, data.id)},
          {[classes.success_large_image]: !["xlarge", "large"].includes(cardSize) && _.includes(success, data.id)},
        )}>
			<div className={classNames({[classes.green_check]: ["xlarge", "large"].includes(cardSize)}, {[classes.green_check_large]: !["xlarge", "large"].includes(cardSize)})}>
				<Check/>
			</div>
		</div>}
        {(newSpecification) && <div className={classNames(
          classes.spec_success,
          {[classes.spec_success_image]: newSpecification}
        )}>
			<div className={classes.green_check}>
				<Check/>
			</div>
		</div>}
        <div
          className={classNames(
            css.drag_container,
            {[css.drag_container_active]: _.includes(drag, data.id)}
          )}
          onDragLeave={(e) => { !isVLPView && onDragLeaveImage(e, data.id) }}
          // onDrop={(e) => { !isVLPView && dragDrop.dragType && onDrop ? onDrop(e, data.id) : onDropImage && onDropImage(e, data)}}
        >
          <div
            className={classNames(
              css.drag,
              {[css.xlarge_image]: cardSize === 'xlarge'},
              {[css.large_image]: cardSize === 'large'},
              {[css.medium_image]: dragType === MEDIUM_IMAGE},
              {[css.drag_attribute]: dragType === ATTRIBUTE},
              {[css.visible]: drag && drag.length && _.includes(drag, data.id)}
            )}>
            <Add className={css.add_icon}/>
          </div>
        </div>
        <div
          className={classNames(
            css.loading,
            {[css.loading_attribute]: _.includes(loading, ATTRIBUTE)}
          )}
        >
          {_.includes(loading, ATTRIBUTE) && <CircularProgress color={'secondary'} className={css.progress}/>}
        </div>
        <div className={classNames(
          css.success,
          {[css.success_attribute]: _.includes(success, ATTRIBUTE)}
        )}>
          {_.includes(success, ATTRIBUTE) && <div className={css.green_check}>
			  <Check/>
		  </div>}
        </div>
        {cardSize != 'mini' &&
		 <CardContent classes={{root: classNames(css.cardContentRoot, classes[isContent ? `${cardSize}_content` : `${cardSize}_nocontent`] + `${isActive === false ? ' inactive' : ''}`)}}>
           {!hideInfo && <List disablePadding className={css.list}>
			   <ListPreviewCard
				   stores={stores}
				   size={cardSize}
				   showImage={false}
				   showHex={false}
				   draggable={false}
				   isSelected={isSelected}
				   cardDetails={{secondary: cardDetails?.secondary}}
				   searchText={searchText}
				   data={data}
				   mapping={mapping}
				   badge2Text={badge2Text}
				   badge1Text={badge1Text}
				   elevation={0}
				   classes={{
                     list: classNames(isLarge ? classes.list : classes.medium_list, css.listPreview_list),
                     card: classes.card,
                     body1: classes[`${cardSize}_body1`],
                     selected: classes.previewSelected,
                     cardHeight: !isLarge ? classes.medium_cardHeight : '',
                     secondaryText: !isLarge ? classes.medium_secondaryText : '',
                     titleWrapper: classes.titleWrapper
                   }}
			   />
		   </List>}
           {isLarge ? !_.includes(loading, 'tags') ? isAttributes && data.attributes && data.attributes.length > 0 &&
             [
               isContent ? <Divider key={`tag-attr-${data.id}`}/> : null,
               <div onDragEnter={(e) => { onDragEnterSpecification(e, 'tag') }} onDragOver={(e) => { onDragEnterSpecification(e, 'tag') }}
                    onDragLeave={(e) => { onDragLeaveSpecification(e, 'tag') }} key={`tag-attr-cont-${data.id}`} className={classes.chipContainer}>
                 {_.map(data.attributes, (attribute) => {
                   return (
                     <Chip draggable key={attribute.id} classes={{root: classes.chip, label: classes.chipLabel}} label={attribute.name}/>
                   )
                 })}
               </div>,
               isContent ? null : <Divider key={`bottom-border-no-content-${data.id}`}/>
             ] : <Fragment>
                        <Divider key={`loading-divider-${data.id}`}/>
                        <div key={`loading-progress-bar-${data.id}`} className={classes.loadingTags}>
                          <CircularProgress size={!isLarge ? 20 : 50} color={'secondary'}/>
                        </div>
                      </Fragment> : null
           }
           {children}
		 </CardContent>}
        {isActions &&
		 <CardActions className={classes[`${cardSize}_actions`] + `${isActive === false ? ' inactive' : ''}`}>
           {(showAddedText && disableAddToSeason) && <Typography classes={{body2: classes.inactiveText}} variant={'body2'}>{`Added`}</Typography>}
           {showFavorite && <PrimaryIconButton
			   icon={<FavoriteBorder className={classNames(classes[`${cardSize}_moreIcon`], classes.darkIcon)}/>}
			   disabled={false}
			   className={!isLarge ? classes.icon : ''}
			   onClick={(e) => { onClickFavorite(e, data.id) }}
		   />}
           {isComments && <PrimaryIconButton
			   icon={<Comment className={classNames(classes.commentsIcon, classes.darkIcon)}/>}
			   disabled={false}
			   onClick={(e) => { onClickComment && onClickComment(e, data.id) }}
		   />}
           {showMenu && <PrimaryIconButton
			   icon={<MoreHoriz className={classNames(classes[`${cardSize}_moreIcon`], classes.darkIcon)}/>}
			   onClick={(e) => { data.id && onClickMoreMenu(e) }}
			   className={!isLarge ? classes.icon : ''}
		   />}
           {showDownloadInProgress
            ? <div className={classes[`${cardSize}_action_progress`]}>
              <CircularProgress size={isLarge ? 20 : 18} color={'secondary'}/>
            </div>
            : showDownload
              ? <PrimaryIconButton
                icon={<GetApp className={classNames(classes[`${cardSize}_moreIcon`], classes.darkIcon)}/>}
                onClick={(e) => { onClickDownload && onClickDownload(e, data) }}
                className={!isLarge ? classes.icon : ''}
                disabled={!nav.params.category2}
              />
              : null
           }
           {!showDownloadInProgress && showAddIcon && <PrimaryIconButton
			   icon={<Add className={classNames(classes[`${cardSize}_moreIcon`], classes.darkIcon)}/>}
			   onClick={onClickAddIcon}
			   className={!isLarge ? classes.icon : ''}
			   disabled={!nav.params.category2}
		   />}
           {showCheck && <PrimaryIconButton
			   icon={<Check className={classNames(classes[`${cardSize}_moreIcon`], classes.green)}/>}
			   className={!isLarge ? classNames(classes.icon) : null}
		   />}
		 </CardActions>
        }
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/ListInfoCard/ListInfoCard.tsx